/** Completed-today panel (read-only / inert). */
import { Box } from '@mui/material';
import TaskItemToday from '@/features/tasks/components/items/TaskItemToday';
import Panel from '@/components/ui/Panel';

const PANEL_FLAT_CLASS = 'panel-flat-list';

/**
 * @param {object} props
 * @param {(key: string, fallback: string) => string} props.t
 * @param {import('@/types').Task[]} props.completedTodayTasks
 */
export function TodayCompletedPanel({ t, completedTodayTasks }) {
  if (completedTodayTasks.length === 0) return null;

  return (
    <Panel
      flat
      contentClassName={PANEL_FLAT_CLASS}
      title={t('todayviewcontent.completed', 'Completed')}
      count={completedTodayTasks.length}
      defaultOpen={false}
      testId="panel-completed"
      tabIndex={-1}
    >
      <Box
        inert
        sx={{ display: 'flex', flexDirection: 'column', opacity: 0.7 }}
      >
        {completedTodayTasks.map((task) => (
          <TaskItemToday
            key={task.id}
            task={task}
            indentationType="none"
            view="today"
            showPlayButton={false}
          />
        ))}
      </Box>
    </Panel>
  );
}
